export default __webpack_public_path__ + "static/media/edit-file.4caf37b0.svg";